import { heroStats } from '@/mocks/drama';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20background%20of%20a%20dim%20elegant%20family%20living%20room%20at%20night%2C%20warm%20amber%20and%20deep%20crimson%20light%20through%20tall%20windows%2C%20heavy%20velvet%20curtains%20and%20a%20single%20armchair%20with%20soft%20shadows%2C%20dramatic%20chiaroscuro%20mood%2C%20artistic%20editorial%20composition%2C%20moody%20color%20grading%20with%20dark%20negative%20space%2C%20soft%20film%20grain%2C%20no%20people&width=1920&height=1080&seq=drama-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />

      <div className="relative mx-auto flex min-h-[600px] md:min-h-[88vh] max-w-7xl flex-col justify-center px-4 py-24 md:px-8">
        <div className="w-full max-w-3xl">
          <div className="flex flex-wrap items-center gap-3">
            <span className="rounded-full border border-background-100/40 px-3 py-1 text-xs font-label tracking-[0.2em] text-background-100">
              短剧 · 小说
            </span>
            <span className="rounded-full bg-accent-500/90 px-3 py-1 text-xs font-label font-medium tracking-[0.1em] text-foreground-950">
              深度解析
            </span>
          </div>

          <h1 className="mt-5 font-heading text-3xl md:text-6xl font-bold leading-[1.15] text-background-50">
            《继母的诱惑》
            <br className="hidden sm:block" />
            <span className="text-accent-300">剧情深度解析</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-lg leading-relaxed text-background-100">
            从完整版剧情脉络到未删减细节，从人物关系梳理到同类伦理题材作品推荐，
            一站式帮你看懂故事走向，找到风格相近的后续剧集与读物。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#plot"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors"
            >
              查看剧情脉络
            </a>
            <a
              href="#recommend"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-100/50 px-6 py-3 text-center text-sm font-label font-medium text-background-50 hover:bg-white/10 transition-colors"
            >
              浏览类似推荐
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l border-background-100/30 pl-4">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-300">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs md:text-sm font-label text-background-200">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}